// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'confetti';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round'>
    <path d='M11.297 11.962c.726-.726.138-2.492-1.315-3.944C8.53 6.565 6.764 5.977 6.038 6.703S5.9 9.195 7.353 10.647c1.452 1.452 3.218 2.041 3.944 1.315z' />
    <path d='m5.742 7.37-4.613 8.09a1.062 1.062 0 0 0 1.41 1.411l8.09-4.61M9.607 1.031a9.8 9.8 0 0 1-.376 3.981m3.005-3.005-.375 1.878m5.108 4.508a9.8 9.8 0 0 0-3.981.376m3.005-3.005-1.878.375M6.226 4.15a.266.266 0 1 1 0-.53m0 .53a.266.266 0 1 0 0-.53m5.259 2.785a.266.266 0 0 1 0-.531m0 .531a.266.266 0 0 0 0-.531M14.49 3.4a.266.266 0 0 1 0-.531m0 .531a.266.266 0 1 0 0-.531m0 8.044a.266.266 0 1 1 0-.532m0 .532a.266.266 0 1 0 0-.532' />
  </g>
);

export const viewBox = '0 0 18 18';
